/* eslint-disable default-param-last */
import { EntityType } from '../../types/enums';
import { TotalOTStats } from '../../utils/video/opentok-connection';
import {
	SET_OPENTOK_STATS,
	SET_SHOW_DEBUG_UI,
	OPENTOK_STREAM_AUDIO_ADD_UNMUTED_ID,
	OPENTOK_STREAM_AUDIO_REMOVE_UNMUTED_ID,
} from '../actions/opentok';
import { Action } from '../types/types';

export interface OpenTokState {
	openTokStats: TotalOTStats;
	showDebugUI: boolean;
	unmutedAudioFeeds: string[];
	opentokSession: string | null;
	sessionInitialized: boolean;
}

export const initialOpenTokState: OpenTokState = {
	openTokStats: {},
	showDebugUI: false,
	unmutedAudioFeeds: [],
	opentokSession: null,
	sessionInitialized: false,
};

const actions: Map<string, Function> = new Map([
	[SET_OPENTOK_STATS, (state: OpenTokState, action: Action) => (
		{ ...state, openTokStats: action.payload }
	)],
	[SET_SHOW_DEBUG_UI, (state: OpenTokState, action: Action) => (
		{ ...state, showDebugUI: action.payload }
	)],
	[OPENTOK_STREAM_AUDIO_ADD_UNMUTED_ID, (state: OpenTokState, action: Action) => {
		if (!state.unmutedAudioFeeds?.includes(action.payload)) {
			return {
				...state,
				unmutedAudioFeeds: [
					...state.unmutedAudioFeeds,
					action.payload,
				],
			};
		}
		return state;
	}],
	[OPENTOK_STREAM_AUDIO_REMOVE_UNMUTED_ID, (state: OpenTokState, action: Action) => ({
		...state,
		unmutedAudioFeeds: state.unmutedAudioFeeds.filter((id) => id !== action.payload),
	})],
	[
		EntityType.opentokSession,
		(state: OpenTokState, action: Action): OpenTokState => ({
			...state,
			opentokSession: action.payload?.entityValue?.sessionId ?? null,
			sessionInitialized: true,
		}),
	],
]);

export function OpenTokReducer(state: OpenTokState = initialOpenTokState, action: Action) {
	return actions.get(action.type)?.(state, action) || state;
}
